<template>
   <div>
     <OrderDetail :orderInfo="order" />
   </div>
</template>
<script>

import OrderDetail from '../components/OrderDetail/OrderDetail.vue'
import { order_detail } from '../api/api.js';
export default {
   name: 'OrderDetailPage',
   components: {
     OrderDetail
   },
   data() {
     return {
       order:null
     }
   },
   computed: {
     
   },
   watch: {
     
   },
   mounted() {

     const orderSn = this.$route.query.order_sn;

     this.load_order(orderSn)

   },
   methods: {
     async load_order(order_sn){

        if(!order_sn){
            this.$message.error("订单sn不能为空")
            return
        }

        try {
            const res = await order_detail(order_sn)
            
            this.order = res
        } catch (error) {
            this.$message.error(error)
        }
       
     },
   }
};
</script>
<style scoped>
</style>